import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { ScrollPanel } from 'primereact/scrollpanel';
import { injectIntl, defineMessages } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { withAccount } from '../../../../components/AccountContext';
import UpdateCurrentAriAnswers from './UpdateCurrentAriAnswers';
import { ACCOUNT_QUERY } from '../../../Accounts/ARI/queries';
import OverwriteAriAnswers from './OverwriteAriAnswers';
import { Loading } from '../../../../components/Loading';


const ariMessages = defineMessages({
  dialogHeader: {
    id: 'ari.respondent.edit.dialog.header',
    defaultMessage: 'Update ARI answers',
  },
});

const RespondentEditAriFieldsModal = ({
  isVisible, setIsVisible, respondent, currentAccount, intl: { formatMessage },
}) => {
  const { data, loading } = useQuery(ACCOUNT_QUERY, { variables: { accountId: currentAccount } });
  const [accountGlobalAri, setAccountGlobalAri] = useState(null);
  const [accountLocalAri, setAccountLocalAri] = useState(null);
  const [respondentHasSameAriFieldsAsAccount, setRespondentHasSameAriFieldsAsAccount] = useState(false);

  useEffect(() => {
    if (data && data.account) {
      setAccountGlobalAri(data.account.globalAriFields);
      setAccountLocalAri(data.account.localAriFields);

      setRespondentHasSameAriFieldsAsAccount(
        (respondent.globalAriFields.length + respondent.localAriFields.length)
        === (data.account.globalAriFields.length + data.account.localAriFields.length),
      );
    }
  }, [data, respondent]);

  return (
    <Dialog
      header={formatMessage(ariMessages.dialogHeader)}
      visible={isVisible}
      modal
      onHide={() => setIsVisible(false)}
      style={{ width: '50%' }}
    >
      {
        loading ? (
          <Loading />
        ) : (
          <ScrollPanel style={{ width: '100%', height: '400px' }}>
            {
                !respondentHasSameAriFieldsAsAccount
                && (
                  <OverwriteAriAnswers
                    currentAccount={currentAccount}
                    respondent={respondent}
                    setIsVisible={setIsVisible}
                    accountGlobalAri={accountGlobalAri}
                    accountLocalAri={accountLocalAri}
                  />
                )
              }
            {
                respondentHasSameAriFieldsAsAccount
                && (
                  <UpdateCurrentAriAnswers
                    currentAccount={currentAccount}
                    respondent={respondent}
                    setIsVisible={setIsVisible}
                  />
                )
              }
          </ScrollPanel>
        )
      }
    </Dialog>
  );
};

RespondentEditAriFieldsModal.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  setIsVisible: PropTypes.func.isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withAccount(injectIntl(RespondentEditAriFieldsModal));
